import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { Avatar } from "../../../Avatar";

export interface HistoryDetailViewMemberProps {
  body: {
    community_member_id: number;
  };
  communitySegmentId: number | null;
}

export const HistoryDetailViewMember = ({
  body,
}: HistoryDetailViewMemberProps) => {
  const { community_member_id: communityMemberId } = body;

  return (
    <div className="md:flex">
      <div className="w-1/4">
        <Typography.LabelSm weight="semibold">
          {t("settings.workflows.action_messages.member")}
        </Typography.LabelSm>
      </div>
      <div className="w-3/4">
        <Avatar communityMemberId={communityMemberId} />
      </div>
    </div>
  );
};
